import classNames from "classnames";

import { getProgressBetweenDates } from "../../helpers/DateHelpers";
import parseDate from "../Utils/parseDate";

const ProgressBar = props => {
  const { startDate, endDate, progress, stepDetailsId } = props;

  const startDateParse = startDate && parseDate(startDate);
  const endDateParse = endDate && parseDate(endDate);

  const progressValue = progress || getProgressBetweenDates(startDateParse, endDateParse);

  const ariaLabelledby = stepDetailsId ? stepDetailsId : null;
  const className = classNames(["progress", props.className]);

  const progressValueNow = Math.round(progressValue);

  return (
    <span className={className}>
      <span
        className="progress-bar bg-primary"
        role="meter"
        style={{ width: progressValue + "%" }}
        aria-valuenow={progressValueNow}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-labelledby={ariaLabelledby}
      />
    </span>
  );
};

export default ProgressBar;
